import React, {Component} from 'react'
import {Button} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import { Close } from '@mui/icons-material'

class MessageEditDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: this.props.isMessageEditDialogOpen || false, confirmDeleteOpen: false,
        };
    }

    handleConfirmDeleteClick = () => {
        this.setState({confirmDeleteOpen: true});
    }

    handleConfirmDeleteClose = () => {
        this.setState({confirmDeleteOpen: false});
    }

    handleClose = () => {
        this.setState({open: false});
        this.props.onClose();

    }

    onDeleteMessage = (messageId) => {
        this.setState({
            confirmDeleteOpen: false, open: false,
        });
        this.props.handleDeleteMessage(messageId);
    };

    handleReplyClick = () => {
        this.props.handleReplyMessage(this.props.selectedMessage);
    };
    handleEditClick = () => {
        this.props.handleEditMessage(this.props.selectedMessage);
    };

    render() {

        const {open, confirmDeleteOpen} = this.state;
        const {selectedMessage, isChatClosed} = this.props;
        const messageId = selectedMessage.ID
        const isEditableandDeletable =  !selectedMessage.user_id

        const buttonsConfig = isChatClosed ? [
            {
                label: 'Cancel',
                onClick: this.handleClose,
                show: true
            }
        ] : [
            {
                label: 'Delete',
                onClick: this.handleConfirmDeleteClick, 
                icon: <DeleteOutlinedIcon />,      
                show: isEditableandDeletable 
            },
            {
                label: 'Edit',
                onClick: this.handleEditClick,  
                icon: <EditIcon />,
                show: isEditableandDeletable 
            },
            {/* TODO: Enable reply option after reply feature fix  */}
            // {
            //     label: 'Reply',
            //     onClick: this.handleReplyClick,
            //     icon: <ReplyOutlinedIcon />,
            //     show: true 
            // },
        ];
        

        const styles = {
            dialogTitle: {
                textAlign: 'left',
                color: '#1C1D1F',
                fontSize: 16,
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: '600',
                wordWrap: 'break-word',
                marginBottom: 12,
                padding: 0,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }, button: {
                display: 'flex',
                color: "#3F3D3D",
                backgroundColor: "#E8E5E0",
                fontFamily: "'Open Sans', sans-serif",
                fontSize: 16,
                textTransform: "none",
                borderRadius: '15px',
                padding:'10px',
                width: '100%',
                justifyContent: 'left'
            }, dialogContainer: {
                display: 'flex',
                alignItems: 'center',
                borderRadius: 10,
                padding: 10,
                paddingRight: 100,
                marginBottom: 10,
                fontFamily: "'Open Sans', sans-serif",
                cursor: 'pointer',
            }, dialogIcon: {
                color: '#ffffff', marginRight: 8, width: 20, height: 20,
            },
        }


        return (<>
            <Dialog  
                open={open} onClose={this.handleClose}
                aria-labelledby='dialog-title' aria-describedby='dialog-description'
                PaperProps={{
                    style: {
                        display: 'flex',
                        justifyContent: 'center',
                        borderRadius: '6px',
                        backgroundColor: '#FFFFFF',
                        boxShadow: 'none',
                        minWidth: '300px'
                    }
                }}>
                <div style={{padding: '12px'}}>
                    <DialogTitle id='dialog-title' style={styles.dialogTitle}>{isChatClosed ? "Chat is closed" : "Options "}  <Close onClick={this.handleClose} /></DialogTitle>
                    <DialogContent sx={{padding: '0', gap: 12}}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <div style={{display: 'flex', width: '100%', gap: 8, marginBottom: 8, flexDirection:'column'}}>
                              
                                {buttonsConfig.map((button, index) => button.show && (
                                    <Button
                                        key={index}
                                        onClick={button.onClick}
                                        style={styles.button}
                                        startIcon={button.icon}
                                    >
                                        {button.label}
                                    </Button>
                                ))}
                                
                            </div>

                        </div>
                    </DialogContent>
                </div>
            </Dialog>
            <Dialog
                sx={{zIndex: 9999999999}}
                PaperProps={{
                    style: {
                        display: 'flex',
                        justifyContent: 'center',
                        borderRadius: '10px',
                        backgroundColor: '#FFFFFF',
                        boxShadow: 'none',
                    }
                }}
                open={confirmDeleteOpen} onClose={this.handleConfirmDeleteClose}
                aria-labelledby='second-dialog-title' aria-describedby='second-dialog-description'>
                <DialogTitle id='second-dialog-title' style={{...styles.dialogTitle, marginTop: 12, marginLeft:'6px'}}>Delete
                    message?</DialogTitle>
                <DialogContent sx={{padding: '0', gap: 12}}>
                    <div style={{display: 'flex', gap: 8, padding: '0 12px', marginBottom: 12}}>
                        <Button onClick={this.handleConfirmDeleteClose}
                                style={{...styles.button}}>Cancel</Button>
                        <Button onClick={() => this.onDeleteMessage(messageId)}
                                style={{...styles.button}}>Delete</Button>
                    </div>
                </DialogContent>

            </Dialog>
        </>);
    }
}

export default MessageEditDialog